import { convertCentsToDollars } from '@library/utils/payments';

export interface NumberPanelProps {
  field: string;
  quantity: number;
  refund?: boolean;
}

export const NumberPanel = ({
  field,
  quantity,
  refund = false
}: NumberPanelProps) => {
  const formattedQuantity = refund
    ? convertCentsToDollars(quantity)
    : new Intl.NumberFormat().format(quantity);

  return (
    <div className="bg-soFresh-110 border-soFresh-130 flex flex-1 flex-col items-center justify-center self-stretch rounded-lg border p-6">
      <p className="text-soClean-180 text-sm">{field}</p>
      <p className="text-soClean-100 text-lg">
        {refund && quantity > 0 ? `-${formattedQuantity}` : formattedQuantity}
      </p>
    </div>
  );
};
